// extracted by mini-css-extract-plugin
export default {"submissionContainer":"_23blN","single":"_3njK8","contentWrapper":"_5eHiB","submissionTitle":"JOQQr","processing":"_3MNa5","accepted":"_3jWPv","rejected":"_3oXXB","failed":"hxVPF"};